import LogMSColumn2d from '../logmscolumn2d';
import StackManager from '@fusioncharts/charts/src/dataset/groups/cartesian-stack';

class LogStackedColumn2d extends LogMSColumn2d {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'LogStackedColumn2d';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'LogStackedColumn2d';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    this.config.isstacked = true;
  }
  getDSGroupdef () {
    return StackManager;
  }
}
export default LogStackedColumn2d;
